import contextChannelIdLink from "@magalu/ecomm-components/rave/apollo/contextChannelIdLink";

import { errorLink } from "./errorLink";

export const middlewares = [
  contextChannelIdLink({ isMiniApp: true }),
  errorLink,
];
